import { ILanguageData } from 'interfaces/queries/language';
import { useState, useEffect } from 'react';

interface LanguageState {
  currentLanguage: string | null;
  error: Error | null;
  savePreferredLang: (_lang: string) => void;
  savePreferredLangData: (_languageData: string) => void;
  languageData?: string;
  currentLanguageData: ILanguageData[] | null;
}

const usePreferredLang = (): LanguageState => {
  const [language, setLanguage] = useState<string | null>(null);
  const [languageData, setLanguageData] = useState<ILanguageData[] | null>(
    null
  );
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    const fetchPreferred = async () => {
      try {
        const savedLang = localStorage.getItem('currentLanguage');
        const savedLangData: any = localStorage.getItem('currentLangData');

        if (savedLang) {
          setLanguage(savedLang);
        } else {
          // No language saved, detect from location
          try {
            const response = await fetch('https://ipapi.co/json/');
            const data = await response.json();
            const countryCode = data.country_code;

            // List of French speaking countries (Codes)
            const frenchSpeakingCountries = ['FR', 'CA', 'BE', 'CH', 'LU', 'MC', 'SN', 'CI', 'CM', 'ML', 'GN', 'BF', 'NE', 'TG', 'BJ', 'CD', 'CG', 'GA', 'GQ', 'CF', 'TD', 'BI', 'RW', 'DJ', 'HT', 'VU', 'SC', 'KM', 'MG'];

            const detectedLang = frenchSpeakingCountries.includes(countryCode) ? 'fr' : 'en';
            savePreferredLang(detectedLang);
          } catch (geoError) {
            console.error('Geo detection failed:', geoError);
            // Default to english if detection fails
            setLanguage('en');
          }
        }

        if (savedLangData) {
          setLanguageData(JSON.parse(savedLangData));
        }
      } catch (error) {
        setError(error as Error);
      }
    };

    fetchPreferred();
  }, []);

  const savePreferredLang = (lang: string) => {
    try {
      const normalized = String(lang).toLowerCase().includes('fr') || lang === '2' ? 'fr' : 'en';
      localStorage.setItem('currentLanguage', normalized);
      localStorage.setItem('preferredLang', normalized);
      localStorage.setItem('lang', normalized);
      localStorage.setItem('i18nextLng', normalized);
      setLanguage(normalized);
    } catch (error) {
      setError(error as Error);
    }
  };

  const savePreferredLangData = (languageData: string) => {
    try {
      localStorage.setItem('currentLangData', languageData);
    } catch (error) {
      setError(error as Error);
    }
  };

  return {
    currentLanguage: language,
    error,
    savePreferredLang,
    currentLanguageData: languageData,
    savePreferredLangData,
  };
};

export default usePreferredLang;
